module.exports = __webpack_public_path__ + "static/img/product_banner.831ace7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner.jpg
// module id = EOGk
// module chunks = 1